import type { Social } from '.';

import { SB, searchableComputedProperty } from '@play-co/replicant';

export const socialProperties = {
  isOnline: searchableComputedProperty(
    SB.boolean(),
    ({ isOnline }: Social.State) => isOnline,
  ),
};
